import { CONSTANTS } from '../../_data/lookups.js';
import { getToolStepShortCircuitDecision, shouldRouteBranchStepToExitRebind, shouldRouteToBranchExitRebindAtBoundary, } from './branchRouting.js';
import { shouldSkipLoopCloneAfterFalseWhen } from './loopRouting.js';
export function getExecutionTarget(step) {
    if (step.stepKind === CONSTANTS.Enums.StepKind.tool)
        return 'tool';
    if (step.stepKind === CONSTANTS.Enums.StepKind.branch)
        return 'branch';
    if (step.stepKind === CONSTANTS.Enums.StepKind.while)
        return 'while';
    if (step.stepKind === CONSTANTS.Enums.StepKind.for)
        return 'for';
    return 'end';
}
export function resolveExecutionRoute(state, threadIndex) {
    const threadSteps = state.mutableWorkflow.stepsByThreadIndex[threadIndex];
    if (!threadSteps)
        return { routeKind: 'missing_thread', threadIndex };
    const currentStepCounter = state.stepCounters[threadIndex] ?? 0;
    if (currentStepCounter >= threadSteps.length) {
        return { routeKind: 'target', target: 'thread_end' };
    }
    const step = threadSteps[currentStepCounter];
    if (!step) {
        throw new Error(`Step not found for thread ${threadIndex} at counter ${currentStepCounter}`);
    }
    const args = {
        step, threadSteps, currentStepCounter,
        toolMap: state.toolMap,
        workflowState: state.mutableWorkflow.workflowState,
    };
    if (shouldRouteToBranchExitRebindAtBoundary({
        ...args, rebindGuard: state.branchExitRebindGuardByThreadIndex[threadIndex],
    })) {
        return { routeKind: 'target', target: 'branch_exit_rebind' };
    }
    const shortCircuit = getToolStepShortCircuitDecision({ ...args, currentThreadIndex: threadIndex });
    if (shortCircuit.toolStepShortCircuitDecisionKind === 'end') {
        return { routeKind: 'target', target: 'thread_end' };
    }
    if (shortCircuit.toolStepShortCircuitDecisionKind === 'skipToIndex') {
        const nextStep = threadSteps[shortCircuit.nextIndex];
        if (!nextStep) {
            throw new Error(`Next step not found for thread ${threadIndex} at counter ${shortCircuit.nextIndex}`);
        }
        return { routeKind: 'skip', target: getExecutionTarget(nextStep), threadIndex, nextIndex: shortCircuit.nextIndex };
    }
    if (shouldRouteBranchStepToExitRebind({
        ...args,
        rootBranchStepKeyByRemainderBranchStepKey: state.rootBranchStepKeyByRemainderBranchStepKey,
    })) {
        return { routeKind: 'target', target: 'branch_exit_rebind' };
    }
    if ((step.stepKind === 'while' || step.stepKind === 'for') && shouldSkipLoopCloneAfterFalseWhen(args)) {
        return { routeKind: 'target', target: 'loop_exit_rebind' };
    }
    return { routeKind: 'target', target: getExecutionTarget(step) };
}
